import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/program`;

export const ACTION_TYPES = {
  FETCH_PROGRAM_LIST: 'PROGRAM/FETCH_PROGRAM_LIST',
  FETCH_PROGRAM: 'PROGRAM/FETCH_PROGRAM',
  CREATE_PROGRAM: 'PROGRAM/CREATE_PROGRAM',
  UPDATE_PROGRAM: 'PROGRAM/UPDATE_PROGRAM',
  DELETE_PROGRAM: 'PROGRAM/DELETE_PROGRAM',
  RESET: 'PROGRAM/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const programReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROGRAM_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROGRAM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PROGRAM):
    case REQUEST(ACTION_TYPES.UPDATE_PROGRAM):
    case REQUEST(ACTION_TYPES.DELETE_PROGRAM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROGRAM_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROGRAM):
    case FAILURE(ACTION_TYPES.CREATE_PROGRAM):
    case FAILURE(ACTION_TYPES.UPDATE_PROGRAM):
    case FAILURE(ACTION_TYPES.DELETE_PROGRAM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAM_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAM):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PROGRAM):
    case SUCCESS(ACTION_TYPES.UPDATE_PROGRAM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PROGRAM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default programReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PROGRAM_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesByProgramId = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PROGRAM_LIST,
  payload: axios.get(`${apiUrl}/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesCondition = (condition, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PROGRAM_LIST,
  payload: axios.get(`${apiUrl}/search?name=${condition}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  })
});

export const getEntitiesValidator = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PROGRAM_LIST,
  payload: axios.get(`${apiUrl}/by_validator`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntityByProgramRevision = (id, revisionId) => ({
  type: ACTION_TYPES.FETCH_PROGRAM,
  payload: axios.get(`${apiUrl}/${id}/revision/${revisionId}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PROGRAM,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id, revisionId) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAM,
    payload: axios.patch(`${apiUrl}/${id}/revision/${revisionId}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = (id, revisionId, condition, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PROGRAM,
    payload: axios.delete(`${apiUrl}/${id}/revision/${revisionId}`),
    meta: { errorMessage: `Gagal hapus!`, successMessage: `Berhasil Hapus!` },
  });
  if(condition === ""){
    dispatch(getEntities(page, size, sort));
  }else{
    dispatch(getEntitiesCondition(condition, page, size, sort));
  }
  return result;
};

export const validateEntity = (id, revisionId, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAM,
    payload: axios.post(`${apiUrl}/${id}/revision/${revisionId}/validate`),
    meta: { errorMessage: `Gagal validate!`, successMessage: `Berhasil Validate!` },
  });
  dispatch(getEntities(page, size, sort));
  return result;
};

export const assignEntity = (id, revisionId, deptId, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAM,
    payload: axios.post(`${apiUrl}/${id}/revision/${revisionId}/assign?department_id=${deptId}`),
    meta: { errorMessage: `Gagal Assign!`, successMessage: `Berhasil Assign!` },
  });
  dispatch(getEntities(page, size, sort));
  return result;
};

export const createEntityRevision = (id, entity, condition, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PROGRAM,
    payload: axios.post(`${apiUrl}/${id}/revision`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  if(condition === ""){
    dispatch(getEntities(page, size, sort));
  }else{
    dispatch(getEntitiesCondition(condition, page, size, sort));
  }
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
